// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.3/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.3/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".background-overlay{position:absolute;top:0;bottom:0;left:0;right:0;min-height:calc(100vh - 153px);height:100%;background-color:rgba(0,0,0,.4);z-index:201}.center-loader{position:absolute;top:calc(50% - 16px);left:calc(50% - 16px)}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
